export default {
  decisionPlatform: "",
  access_token: localStorage.getItem("access_token"),
  client_id: "20882088",
  secret: "nGk5R2wrnZqQ02bed29rjzax1QWRIu1O",
  user_name: localStorage.getItem("user_name") || "李娜",
  user_id: 0,
  page_size: 10,
  debug: true,
  CheckSchoolAppCode: "00000000000000000000000000000000",
  //需要登录的模块
  loginModule: [
    "train",
    "group",
    "analysis",
    "statistic",
    "inspection",
    "memorandum",
    "prepare",
    "calendar",
    "email",
    "netteach",
    "alumni",
    "test",
    "schoolroll",
    "exercises",
    "bigdata",
    "examine",
    "vehicle",
    "dormitory",
    "assetManage",
    "canteen",
    "events",
  ],
};
